import {skipToken} from '@reduxjs/toolkit/query';

import {useGetCurrentUserInfoQuery, useGetUserQuery} from '@dms/api/customer';
import {usePermissions} from '@dms/shared';

export function useUserAbsencePermissions(userId: string | undefined) {
  const {data: currentUser, isLoading: isCurrentUserLoading} = useGetCurrentUserInfoQuery();
  const isOwnUser = currentUser?.id === userId;
  const shouldLoadTargetUser = Boolean(currentUser?.id && userId) && !isOwnUser;

  const {data: targetUser, isLoading: isTargetUserLoading} = useGetUserQuery(
    shouldLoadTargetUser ? {id: userId ?? ''} : skipToken
  );

  const branchIds = (isOwnUser ? currentUser?.branches : targetUser?.branches)?.map(
    (branch) => branch.id
  );

  const [canRead, canCreate, canUpdate, canDelete] = usePermissions({
    permissionKeys: [
      'userAbsenceRead',
      'userAbsenceCreate',
      'userAbsenceUpdate',
      'userAbsenceDelete',
    ],
    scopes: {
      userAbsenceRead: {branchIds},
      userAbsenceCreate: {branchIds},
      userAbsenceUpdate: {branchIds},
      userAbsenceDelete: {branchIds},
    },
  });

  return {
    canRead: Boolean(userId && (isOwnUser || canRead)),
    canCreate: Boolean(userId && (isOwnUser || canCreate)),
    canUpdate: Boolean(userId && (isOwnUser || canUpdate)),
    canDelete: Boolean(userId && (isOwnUser || canDelete)),
    isOwnUser,
    isLoading: isCurrentUserLoading || isTargetUserLoading,
  };
}
